import { defineMessages } from 'react-intl';

export default defineMessages({
    relatedBy: {
        id: 'gateway.associated.contacts.AccountRelationshipType.Related by',
        defaultMessage: 'Related By',
    },
});
